/* danchel — Interaktionen: Reveals, Ticker, FAQ/Akkordeon, Galerie, Varianten, Lieferdatum */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveals(scope){
    var els = (scope || document).querySelectorAll('.rv,.rv-img,.rv-up,.js-swipe,.js-line');
    if(reduce){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.14, rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){ io.observe(el); });
  }

  function tilt(scope){
    if(reduce || !matchMedia('(hover:hover)').matches) return;
    (scope || document).querySelectorAll('.js-tilt').forEach(function(card){
      if(card.dataset.tilt) return; card.dataset.tilt = '1';
      card.addEventListener('pointermove', function(e){
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = 'perspective(900px) rotateY(' + (x*7) + 'deg) rotateX(' + (-y*7) + 'deg) translateY(-5px)';
      });
      card.addEventListener('pointerleave', function(){ card.style.transform = ''; });
    });
  }

  function ticker(scope){
    (scope || document).querySelectorAll('[data-dan-ticker]').forEach(function(row){
      if(row.dataset.dup) return; row.dataset.dup = '1';
      row.innerHTML += row.innerHTML;
    });
  }

  function collapsible(scope, itemSel, headSel, bodySel){
    (scope || document).querySelectorAll(itemSel).forEach(function(item){
      var head = item.querySelector(headSel), body = item.querySelector(bodySel);
      if(!head || !body || head.dataset.bound) return;
      head.dataset.bound = '1';
      if(item.classList.contains('open')) body.style.height = body.firstElementChild.offsetHeight + 'px';
      head.addEventListener('click', function(){
        var open = item.classList.toggle('open');
        body.style.height = open ? body.firstElementChild.offsetHeight + 'px' : '0px';
      });
    });
  }

  function gallery(scope){
    (scope || document).querySelectorAll('[data-dan-gallery]').forEach(function(root){
      if(root.dataset.bound) return; root.dataset.bound = '1';
      var shots = root.querySelectorAll('.stagebox img'),
          thumbs = root.querySelectorAll('.thumb'),
          cv = root.querySelector('canvas'),
          hint = root.querySelector('.stagebox__hint');
      function pick(i){
        thumbs.forEach(function(x){ x.classList.toggle('sel', x.dataset.i === i); });
        shots.forEach(function(s){ s.classList.toggle('on', s.dataset.i === i); });
        if(cv) cv.classList.toggle('on', i === '0');
        if(hint) hint.classList.toggle('on', i === '0');
      }
      pick(cv ? '0' : (thumbs[0] ? thumbs[0].dataset.i : '1'));
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){ pick(t.dataset.i); });
      });
    });
  }

  /* Varianten + Menge + Gesamtpreis */
  function buybox(scope){
    (scope || document).querySelectorAll('[data-dan-buy]').forEach(function(root){
      if(root.dataset.bound) return; root.dataset.bound = '1';
      var opts = root.querySelectorAll('.bundle'),
          hidden = root.querySelector('input[name="id"]'),
          qtyIn = root.querySelector('input[name="quantity"]'),
          qtyVal = root.querySelector('[data-qty-val]'),
          qtyHint = root.querySelector('[data-qty-hint]'),
          now = root.querySelector('[data-price-now]'),
          was = root.querySelector('[data-price-was]'),
          base = root.querySelector('[data-price-base]'),
          total = root.querySelector('[data-price-total]'),
          sticky = document.querySelector('[data-sticky-price]'),
          stickyQty = document.querySelector('[data-sticky-qty]'),
          qty = 1, cur = root.querySelector('.bundle.sel') || opts[0];

      function money(cents){
        return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      }
      function render(){
        if(!cur) return;
        var price = +cur.dataset.price, cmp = +cur.dataset.compare || 0,
            pcs = +cur.dataset.pieces || 1, grams = +cur.dataset.grams || 10;
        if(hidden) hidden.value = cur.dataset.variant;
        if(qtyIn) qtyIn.value = qty;
        if(now) now.innerHTML = money(price);
        if(was){ was.innerHTML = cmp ? money(cmp) : ''; was.style.display = cmp ? '' : 'none'; }
        if(base) base.innerHTML = money(price / (pcs * grams) * 100);
        if(total) total.innerHTML = money(price * qty);
        if(qtyVal) qtyVal.textContent = qty;
        if(qtyHint) qtyHint.innerHTML = qty + '&nbsp;&times; Set &middot; ' + (pcs * qty) + '&nbsp;Stick' + (pcs * qty > 1 ? 's' : '') + ' gesamt';
        if(sticky) sticky.innerHTML = money(price * qty);
        if(stickyQty) stickyQty.innerHTML = (pcs * qty) + ' Stick' + (pcs * qty > 1 ? 's' : '') + ' &middot; inkl. MwSt.';
      }
      opts.forEach(function(b){
        b.addEventListener('click', function(){
          opts.forEach(function(o){ o.classList.remove('sel'); o.setAttribute('aria-checked','false'); });
          b.classList.add('sel'); b.setAttribute('aria-checked','true'); cur = b; render();
        });
      });
      var plus = root.querySelector('[data-qty-plus]'), minus = root.querySelector('[data-qty-minus]');
      if(plus) plus.addEventListener('click', function(){ if(qty < 9){ qty++; render(); } });
      if(minus) minus.addEventListener('click', function(){ if(qty > 1){ qty--; render(); } });
      render();
    });
  }

  /* Lieferfenster + Versand-Cutoff */
  function delivery(scope){
    (scope || document).querySelectorAll('[data-dan-deliv]').forEach(function(box){
      if(box.dataset.bound) return; box.dataset.bound = '1';
      var dateEl = box.querySelector('[data-deliv-date]'), cutEl = box.querySelector('[data-deliv-cut]');
      var minD = +box.dataset.min || 2, maxD = +box.dataset.max || 4, hour = +box.dataset.cutoff || 15;
      var M = ['Jan.','Feb.','M\u00e4rz','Apr.','Mai','Juni','Juli','Aug.','Sep.','Okt.','Nov.','Dez.'];
      var W = ['So.','Mo.','Di.','Mi.','Do.','Fr.','Sa.'];
      function work(d, n){
        var x = new Date(d);
        while(n > 0){ x.setDate(x.getDate() + 1); if(x.getDay() % 6) n--; }
        return x;
      }
      function fmt(d){ return W[d.getDay()] + ' ' + d.getDate() + '. ' + M[d.getMonth()]; }
      if(dateEl){
        var n0 = new Date();
        dateEl.innerHTML = fmt(work(n0, minD)) + ' \u2013 ' + fmt(work(n0, maxD));
      }
      if(cutEl){
        (function tick(){
          var n = new Date(), end = new Date(n); end.setHours(hour, 0, 0, 0);
          if(!(n.getDay() % 6) || n >= end){ cutEl.innerHTML = 'Versand am n\u00e4chsten Werktag'; }
          else {
            var ms = end - n;
            cutEl.innerHTML = 'Noch <b>' + Math.floor(ms / 3600000) + '&nbsp;Std ' +
              Math.floor(ms % 3600000 / 60000) + '&nbsp;Min</b> f\u00fcr Versand heute';
          }
          setTimeout(tick, 30000);
        })();
      }
    });
  }

  function stickyBar(){
    var bar = document.querySelector('[data-dan-sticky]');
    if(!bar || bar.dataset.bound) return; bar.dataset.bound = '1';
    var anchor = document.querySelector('[data-dan-buy] button[type="submit"], [data-dan-buy] .btn--wide');
    addEventListener('scroll', function(){
      if(!anchor){ bar.classList.toggle('on', scrollY > innerHeight); return; }
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('on', r.bottom < 0 || r.top > innerHeight);
    }, {passive:true});
  }

  function init(scope){
    reveals(scope); tilt(scope); ticker(scope); gallery(scope);
    buybox(scope); delivery(scope); stickyBar();
    collapsible(scope, '.faq__i', '.faq__h', '.faq__c');
    collapsible(scope, '.acc__i', '.acc__h', '.acc__c');
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  addEventListener('resize', function(){
    document.querySelectorAll('.faq__i.open .faq__c, .acc__i.open .acc__c').forEach(function(b){
      b.style.height = b.firstElementChild.offsetHeight + 'px';
    });
  });
})();
